var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExpertchat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-34.000000, -874.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1.000000, 795.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-Out-Copy-2",
    transform: "translate(32.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.998265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Communication-/-textsms",
    transform: "translate(0.000000, 1.199479)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13.8974164 0 13.8974164 13.8974164 0 13.8974164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5811803,1.15811803 L2.31623607,1.15811803 C1.67927115,1.15811803 1.15811803,1.67927115 1.15811803,2.31623607 L1.15811803,12.7392984 L3.4743541,10.4230623 L11.5811803,10.4230623 C12.2181453,10.4230623 12.7392984,9.90190919 12.7392984,9.26494427 L12.7392984,2.31623607 C12.7392984,1.67927115 12.2181453,1.15811803 11.5811803,1.15811803 Z M11.5811803,9.26494427 L3.4743541,9.26494427 L2.31623607,10.4230623 L2.31623607,2.31623607 L11.5811803,2.31623607 L11.5811803,9.26494427 Z M4.05341312,5.21153115 L5.21153115,5.21153115 L5.21153115,6.36964919 L4.05341312,6.36964919 L4.05341312,5.21153115 Z M6.36964919,5.21153115 L7.52776722,5.21153115 L7.52776722,6.36964919 L6.36964919,6.36964919 L6.36964919,5.21153115 Z M8.68588526,5.21153115 L9.84400329,5.21153115 L9.84400329,6.36964919 L8.68588526,6.36964919 L8.68588526,5.21153115 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpertchat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expertchat.1d30db36.svg";
export { ForwardRef as ReactComponent };